import React from 'react';
import DetailContainer from '../../../components/dataGrid/components/DetailContainer';
import ItemDetail from '../../../components/dataGrid/components/ItemDetail';
import { CustomChip } from '../../../components/chip/Chip';
import moment from 'moment';

const vigenciaReemplazoColors = {
    "NO_EXISTE": { isGreen: true }, // verde
    "PARCIAL": { isYellow: true }, // amarillo
    "TOTAL": { isRed: true } // rojo
};

const DetalleRowTareas = ({ row }) => {
    const fechaReemplazo =
        row.fechaDesdeReemplazo && row.fechaHastaReemplazo
            ? `${moment(row.fechaDesdeReemplazo).format("DD/MM/YYYY")} - ${moment(
                row.fechaHastaReemplazo
            ).format("DD/MM/YYYY")}`
            : "-";

    return (
        <DetailContainer>
            <ItemDetail>
                <strong>Frecuencia:</strong> {row.frecuencia || "-"}
            </ItemDetail>
            <ItemDetail>
                <strong>F.Asignación:</strong> {row.fechaAsignacion}
            </ItemDetail>
            <ItemDetail>
                <strong>Reemplazo:</strong>{" "}
                {row.vigenciaReemplazo ? (
                    <CustomChip
                        {...vigenciaReemplazoColors[row.vigenciaReemplazo]}
                        sx={{ width: 12, height: 12 }}
                    />
                ) : (
                    "-"
                )}
            </ItemDetail>
            <ItemDetail>
                <strong>Fecha de Reemplazo:</strong> {row.tieneMasDeUnReemplazo ? "Existe más de un reemplazo" :  fechaReemplazo}
            </ItemDetail>
            <ItemDetail>
                <strong>Programa:</strong> {row.programa || "-"}
            </ItemDetail>
            <ItemDetail>
                <strong># Evaluación:</strong> {row.idEvaluacion ?? "-"}
            </ItemDetail>
            <ItemDetail>
                <strong>Ultima visita:</strong> {row.fechaUltimaVisita ? `hace ${Math.round(moment().diff(moment(row.fechaUltimaVisita), 'days', true))} días` : "-"}
            </ItemDetail>
        </DetailContainer>
    );
};

export default DetalleRowTareas;